// 文档： https://gitlab.xunlei.cn/acc-base/login-ui/tree/master/packages/utilities
import {NativeApi} from '@xunlei/xluser-utilities/dist/native-api/interface'
import { checkCanUseNativeApi, createNativeApi } from '@xunlei/xluser-utilities/dist/native-api'
import { DeviceSignUtil, deviceSign2DeviceId } from '@xunlei/xluser-utilities/dist/device-sign-util'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import global from '../store/constantStore'
import { apiOrigin } from '@remote/api/config'

export default (async () => {
  if (isAndroid || isIOS) return {}
  // 创建native api
  let nativeApi: NativeApi | null = null
  if (checkCanUseNativeApi()) {
    nativeApi = createNativeApi('') as NativeApi
    // 初始化
    await nativeApi.init()
    // 获取app信息
    await nativeApi.getAppInfo()
  }

  const deviceSignUtil = new DeviceSignUtil()

  // 初始化
  await deviceSignUtil.init(
    apiOrigin,
    nativeApi as NativeApi,
  )
  function genDeviceSign () {
    // 获取devicesign
    const deviceSign = deviceSignUtil.getDeviceSign()
    return deviceSign
  }
  function genDeviceID () {
    // devicesign转deviceid
    const deviceSign = genDeviceSign()
    const deviceId = deviceSign2DeviceId(deviceSign)
    return deviceId
  }
  const deviceSign = genDeviceSign()
  const deviceID = genDeviceID()
  global.deviceID = deviceID
  global.deviceSign = deviceSign
  return {
    deviceSign,
    deviceID,
  }
})()
